<div class=" filter_content">
	<div class="form-group kt-form__group row">
		<div class="col-lg-3 kt-margin-b-10-tablet-and-mobile">
			<mat-select class="form-control" placeholder="Gün Sayısı" [(ngModel)]="selectedLastNumberDayObj">
				<mat-option *ngFor="let approvalDateFilter of approvalDateFilters"
							[value]="approvalDateFilter"
							(click)="onSelectedNumberOfDays(approvalDateFilter.value)">
					 {{approvalDateFilter.key}} 
				</mat-option>
			</mat-select>
		</div>
		<!--Onay bekleyen taleplerim ve Geçmiş Talepleim sayfasında olacak sadece-->
		<!--<div class="col-lg-2">
			<mat-form-field>
				<mat-select placeholder="Onay Durumu" [(ngModel)]="selectedApprovalStatusObj">
					<mat-option *ngFor="let approvalStatus of approvalStatusList"
								[value]="approvalStatus.key"
								(click)="onSelectedApprovalStatus(approvalStatus)">
				{{approvalStatus.value}}
				</mat-option>
				</mat-select>
			</mat-form-field>
		</div>-->
		<div class="col-md-9">
			<div class="pull-right" [hidden]="(productList | async).length < 1">
				<div ngbDropdown [placement]="'bottom-right'" class="dropdown dropdown-inline">
					<a ngbDropdownToggle href="javascript:;" class="btn btn-success kt-subheader__btn-options">
						{{ 'FE.APPROVALS.TABS.PASTORDERS.BUTTON.EXCEL' | localize }} &nbsp; <i class="la la-angle-down"></i>
					</a>
					<div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
						<a class="dropdown-item" href="javascript:;" (click)="btnExportToExcel(true)"><i class="la la-file-image-o"></i> {{ 'FE.APPROVALS.TABS.PASTORDERS.BUTTON.EXCEL.DOWNLOADWITHPHOTO' | localize }}</a>
						<div class="dropdown-divider"></div>
						<a class="dropdown-item" href="javascript:;" (click)="btnExportToExcel(false)"><i class="la la-file-text"></i>{{ 'FE.APPROVALS.TABS.PASTORDERS.BUTTON.EXCEL.DOWNLOADWITHOUTPHOTO' | localize }}</a>
					</div>
				</div>
				<!--<button type="button" (click)="btnExportToExcel()" class="btn btn-success margin-left-10">Excel'e Aktar</button>-->
			</div>
		</div>
	</div>
</div>

<div [hidden]="(productList | async).length < 1">
	<div *ngFor="let product of (productList | async); let i = index">
		<div class="row bottom-border-1px margin-top-10">
			<div class="col-md-1 margin-bottom-10 " (click)="openImage(product.productCode,product.productName)">
				<img photoUrl alt="" class="kt-widget7__img" width="100%" [attr.src]="getPhotoUrl(product.productCode)" alt="">
			</div>
			<div class="col-md-3 margin-bottom-10">
				<a class="kt-widget5__title code"><strong>{{product.productCode}}</strong></a><br>
				<span class="kt-widget5__desc name">{{product.productName}}</span><br>
				<div class="kt-widget5__info">
					<span class="kt-font-info businessUnitName">{{product.productBusinessUnitName}}</span>,
					<span class="kt-font-info brand">{{product.productBrand}}</span>
					<span class="kt-font-danger deci">&nbsp;*{{product.productDeci}} {{ 'FE.APPROVALS.GRID.DECI' | localize }}</span>
				</div>
				<div class="kt-widget5__info sktLot" *ngIf="product.variationId > 0">

					<span *ngIf="product.expirationDate"><strong>{{ 'FE.APPROVALS.GRID.EXPIRATIONDATE' | localize }} :</strong>{{product.expirationDate}} </span>
					<span *ngIf="product.expirationDate && product.lot"> - </span>
					<span *ngIf="product.lot"><strong>{{ 'FE.APPROVALS.GRID.LOT' | localize }} :</strong>{{product.lot}} </span>
					<span *ngIf="product.lot && product.barcode"> - </span>
					<span *ngIf="product.barcode"><strong>{{ 'FE.APPROVALS.GRID.BARCODE' | localize }} :</strong>{{product.barcode}}</span>

					<!--<span><strong>SKT :</strong>12.12.2020</span>
					<span> - </span>
					<span><strong>LOT :</strong>12.12.2020</span>
					<span> - </span>
					<span><strong>BARKOD :</strong>12.12.2020</span>-->
				</div>
			</div>
			<div class="col-md-1 margin-bottom-10 text-center">
				<span class="kt-widget5__sales">{{ 'FE.APPROVALS.GRID.COLUMN.DATE' | localize }}</span><br>
				<span class="kt-widget5__number date"><strong>{{product.orderDate}}</strong></span><br>
			</div>
			<div class="col-md-2 margin-bottom-10">
				<span class="kt-widget5__sales">{{ 'FE.APPROVALS.GRID.COLUMN.SOURCEADDRESS' | localize }}</span><br>
				<span class="kt-widget5__number sourceAddress"><strong>{{product.sourceAddressName}}</strong></span>
			</div>
			<div class="col-md-2 margin-bottom-10">
				<span class="kt-widget5__sales">{{ 'FE.APPROVALS.GRID.COLUMN.DESTINATIONADDRESS' | localize }}</span><br>
				<span class="kt-widget5__number targetAddress"><strong>{{product.toAddressName}}</strong></span>
			</div>
			<div class="col-md-1 margin-bottom-10 productQuantity text-center">
				<span class="kt-widget5__votes">{{ 'FE.APPROVALS.TABS.PASTORDERS.COLUMN.STATUS' | localize }}</span><br>
				<div>
					<span class="kt-widget5__number"><strong>{{product.approvalStatusText}}</strong></span><br>

					<span  class="la la-info-circle text-success productPiece" placement="top" ngbTooltip="{{product.approvalStatusDescText}}" ngbTooltipClass="kt-tooltip">

						</span>
					<!--<div [ngSwitch]="product.approvedStatusType">

						<span *ngSwitchCase="1" class="la la-clock-o text-success productPiece" placement="top" ngbTooltip="{{product.approvalStatusText}}" ngbTooltipClass="kt-tooltip">

						</span>

						<span *ngSwitchCase="2" class="la la-hourglass-2 text-success productPiece" placement="top" ngbTooltip="{{product.approvalStatusText}}" ngbTooltipClass="kt-tooltip">

						</span>

						<span *ngSwitchCase="3" class="la la-check-circle-o text-success productPiece" placement="top" ngbTooltip="{{product.approvalStatusText}}" ngbTooltipClass="kt-tooltip">

						</span>

						<span *ngSwitchCase="4" class="la la-times-circle-o text-danger productPiece" placement="top" ngbTooltip="{{product.approvalStatusText}}" ngbTooltipClass="kt-tooltip">

						</span>

						<span *ngSwitchCase="5" class="la la-ban text-success productPiece" placement="top" ngbTooltip="{{product.approvalStatusText}}" ngbTooltipClass="kt-tooltip">

						</span>

						<span *ngSwitchCase="6" class="fa fa-hourglass-half text-success productPiece" placement="top" ngbTooltip="{{product.approvalStatusText}}" ngbTooltipClass="kt-tooltip">
							timer
						</span>

						<span *ngSwitchCase="7" class="fa fa-boxes text-success productPiece" placement="top" ngbTooltip="{{product.approvalStatusText}}" ngbTooltipClass="kt-tooltip">
							timer
						</span>

						<span *ngSwitchCase="8" class="fa fa-check-double text-success productPiece" placement="top" ngbTooltip="{{product.approvalStatusText}}" ngbTooltipClass="kt-tooltip">
							timer
						</span>

						<span *ngSwitchCase="9" class="fa fa-pallet text-success productPiece" placement="top" ngbTooltip="{{product.approvalStatusText}}" ngbTooltipClass="kt-tooltip">
							timer
						</span>

						<span *ngSwitchCase="10" class="fa fa-map-signs text-success productPiece" placement="top" ngbTooltip="{{product.approvalStatusText}}" ngbTooltipClass="kt-tooltip">
							timer
						</span>

						<span *ngSwitchCase="11" class="fa fa-truck-moving text-success productPiece" placement="top" ngbTooltip="{{product.approvalStatusText}}" ngbTooltipClass="kt-tooltip">
							timer
						</span>

						<span *ngSwitchCase="12" class="fa fa-user-check text-success productPiece" placement="top" ngbTooltip="{{product.approvalStatusText}}" ngbTooltipClass="kt-tooltip">
							timer
						</span>

						<span *ngSwitchCase="13" class="fa fa-user-times text-danger productPiece" placement="top" ngbTooltip="{{product.approvalStatusText}}" ngbTooltipClass="kt-tooltip">
							timer
						</span>

					</div>-->
				</div>
			</div>
			<div class="col-md-1 margin-bottom-10 productQuantity text-center">
				<span class="kt-widget5__votes">{{ 'FE.APPROVALS.TABS.PASTORDERS.COLUMN.ORDEREDQTY' | localize }}</span><br>
				<span class="kt-widget5__number text-success productPiece">{{product.qty}}</span>
			</div>
			<div class="col-md-1 margin-bottom-10 productQuantity text-center">
				<span class="kt-widget5__votes">{{ 'FE.APPROVALS.TABS.PASTORDERS.COLUMN.APPROVEDQTY' | localize }}</span><br>
				<span class="kt-widget5__number text-success productPiece">{{product.approvedQty}}</span>
			</div>
		</div>
	</div>
</div>

<div *ngIf="(productList | async).length < 1">
	<h5 class="text-center">{{ 'FE.APPROVALS.TABS.PASTORDERS.NOTFOUND' | localize }}</h5>
</div>




